<template>
  <div class="login">
    <LoginForm />
  </div>
</template>

<script>
import LoginForm from '../../../components/login/LoginForm'

export default {
  name: 'Login',

  components: {
    LoginForm
  }
}
</script>

<style>
.login {
  align-items: center;
  background: transparent url('../../../../public/img/insight_img_bg_1.jpg') no-repeat fixed center;
  background-size: cover;
  display: flex;
  height: 100vh;
}
</style>
